
<!-- // FOOTER -->

@if (!cssDisabled) {
  <span id="back-top" style="display: inline;">
    <a href="javascript:void()" (click)="sc()" tabindex="1" class="ng-binding">
      <span class="fa fa-angle-up"></span>
      {{'GENERAL_REUSABLE.TOP' | translate}}
      <!--Top-->
    </a>
  </span>
}
<footer>
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-6 col-12">
        <h5>{{'FOOTER.CONTACT_SUPPORT' | translate}}</h5>
        <h6>{{'FOOTER.CBP_SUPPORT' | translate}}</h6>
        <ul class="button-less">
          <li><a href="https://help.cbp.gov/app/answers/list/kw/Trusted%20Traveler%20Program/search/1" target="_blank" rel="noopener noreferrer" translate>{{'FOOTER.CBP_INFO_CENTER' | translate}}</a>
          <li><a href="" data-bs-toggle="modal" data-bs-target="#mdl-need-help" title="{{'FOOTER.NEED_HELP_LINK_TITLE' | translate}}">{{'FOOTER.NEED_HELP' | translate}}</a></li>
        </ul>

        <!--<h6>{{'FOOTER.CALL_HOURS' | translate}}</h6>
        <ul class="button-less">
          <li>{{'FOOTER.TOLL_FREE' | translate}}: <strong><a href="tel:855-873-4637" title="{{'FOOTER.LINK_TITLE_DOMESTIC_NUMBER' | translate}}">855-USE-GOES</a></strong> (873-4637)</li>
          <li>{{'FOOTER.OUTSIDE_US' | translate}}: <strong><a href="tel:202-325-8060" title="{{'FOOTER.LINK_TITLE_INTERNATIONAL_NUMBER' | translate}}">202-325-8060</a></strong></li>
        </ul>-->
      </div>

      <div class="col-lg-4 col-md-4 col-sm-6 col-12">
        <h5>{{'FOOTER.SECURE_TRANSACTIONS' | translate}}</h5>
        <h6>{{'FOOTER.ACCEPTED_PAYMENT_METHODS' | translate}}</h6>
        <ul class="pay-methods">
          <li><img alt="visa"  [src]="cssDisabled && 'assets/images/icons/icon-visa-rev.png' || 'assets/images/icons/icon-visa.png'" /></li>
          <li><img alt="master card"  [src]="cssDisabled && 'assets/images/icons/icon-mastercard-rev.png' || 'assets/images/icons/icon-mastercard.png'" /></li>
          <li><img alt="discover"  [src]="cssDisabled && 'assets/images/icons/icon-discover-rev.png' || 'assets/images/icons/icon-discover.png'" /></li>
          <li><img alt="american express"  [src]="cssDisabled && 'assets/images/icons/icon-amex-rev.png' || 'assets/images/icons/icon-amex.png'" /></li>
        </ul>
        <br><br>
        <a href="" data-bs-toggle="modal" data-bs-target="#mdl-full-payment-list" title="See full list of payment methods">see full list</a>
      </div>

      <div class="col-lg-4 col-md-4 col-sm-6 col-12">
        <h5>Resources</h5>
        <ul class="resource-list">
          <li><a href="https://www.dhs.gov/" title="{{'FOOTER.LINK_TITLE_DEPT_HOMELAND_SECURITY' | translate}}" target="_blank" rel="noopener noreferrer">DHS.gov</a> ({{'FOOTER.DEPT_HOMELAND_SECURITY' | translate}})</li>
          <li><a href="https://www.cbp.gov/" title="Link to the U.S. Customs and Border Protection website" target="_blank" rel="noopener noreferrer">CBP.gov</a> ({{'FOOTER.CUSTOMS_AND_BORDER_PROTECTION' | translate}})</li>
          <li><a href="https://www.cbp.gov/site-policy-notices/accessibility" target="_blank" rel="noopener noreferrer" title="{{'FOOTER.ACCESSIBILITY' | translate}}">{{'FOOTER.ACCESSIBILITY' | translate}}</a></li>
          <li><a href="" data-bs-toggle="modal" data-bs-target="#mdl-privacy" title="{{'FOOTER.PRIVACY_ACT' | translate}}">{{'FOOTER.PRIVACY_ACT' | translate}}</a></li>
          <li><a href="https://www.cbp.gov/document/directives/vulnerability-disclosure-program-policy-and-rules-engagement" target="_blank" rel="noopener noreferrer" title="{{'FOOTER.VULNERABILITY_DISCLOSURE' | translate}}" translate>FOOTER.VULNERABILITY_DISCLOSURE</a></li>
        </ul>
      </div>

    </div>

  </div>
</footer>

<need-help-modal [id]="'mdl-need-help'"></need-help-modal>

<info-modal
  [id]="'mdl-full-payment-list'"
  [title]="'MODAL.FULL_PAYMENT_LIST_TITLE'"
  [buttonText]="'MODAL.BUTTON_OK'"
[translate-src]="'MODAL.FULL_PAYMENT_LIST'"></info-modal>

<info-modal
  [id]="'mdl-privacy'"
  [title]="'MODAL.PRIVACY_STATEMENT_TITLE'"
  [buttonText]="'MODAL.BUTTON_CLOSE'"
[translate-src]="'MODAL.PRIVACY_STATEMENT'"></info-modal>

<!-- // PAPERWORK REDUCTION ACT NOTICE -->
<div class="paperwork-reduction">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <p [innerHTML]=paperWorkMsg></p>
      </div>
    </div>
  </div>
</div>